// /arena/$id — real route. Mirrors apps/web's app/arena/[id]/page.tsx,
// which is an ASYNC server component that awaits `params` before passing
// `experimentId` to `ExperimentDetailClient` — that await-a-Promise-prop
// shape has no client-side equivalent, so (same rationale as
// routes/chat.$sessionId.tsx bypassing app/chat/[id]/page.tsx) we mount
// `ExperimentDetailClient` directly and thread `$id` through from TanStack's
// synchronous route params instead. Registered from routes/admin.tsx under
// the `_admin` guard (routes/guards.tsx), parity with
// app/arena/layout.tsx:7-8.
import { createRoute } from '@tanstack/react-router';
import { ExperimentDetailClient } from '@/app/arena/[id]/experiment-detail-client';
import { adminRoute } from './guards';

function ArenaDetailRoute() {
  const { id } = arenaDetailRoute.useParams();
  return <ExperimentDetailClient experimentId={id} />;
}

export const arenaDetailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/arena/$id',
  component: ArenaDetailRoute,
});
